var _text, _linearGradient, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafariOriginalWordmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(22.295 126)",
    fill: "#333",
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 36
  }, "Safari")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 295.835,
    y1: 124.728,
    x2: 295.835,
    y2: 123.889,
    gradientTransform: "matrix(112 0 0 -112 -33069.5 13971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E64F0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    cx: 64,
    cy: 48.5,
    r: 47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "none",
    d: "M64 6.1V13m0 70.7v6.9m7.3-83.8l-1.2 6.8M57.9 83.2L56.7 90M78.5 8.7l-2.4 6.5M51.9 81.6l-2.4 6.5m7.2-81.3l1.2 6.8m12.2 69.6l1.2 6.8M49.5 8.7l2.4 6.5m24.2 66.4l2.4 6.5M42.9 11.8l3.4 6M81.7 79l3.4 6M36.8 16l4.5 5.3m45.4 54.1l4.5 5.4M31.6 21.2l5.3 4.5m54.2 45.4l5.3 4.4m-69-48.2l6 3.4m61.2 35.4l6 3.4M24.3 33.9l6.5 2.4m66.4 24.2l6.5 2.3M22.4 41l6.8 1.2m69.6 12.3l6.8 1.2m-83.9-7.3h7m70.6 0h7m-83.9 7.3l6.8-1.2m69.6-12.3l6.8-1.2M24.3 62.8l6.5-2.3m66.4-24.2l6.5-2.4M27.4 69.5l6-3.4m61.2-35.4l6-3.4m-69 48.2l5.3-4.4m54.2-45.4l5.3-4.5M36.8 80.8l4.5-5.4m45.4-54.1l4.5-5.3M42.9 85l3.4-6m35.4-61.2l3.4-6M60.3 6.3l.3 3.7m6.8 76.7l.3 3.8M53.1 7.6l.9 3.6m20 74.3l.9 3.7M46.1 10.1l1.6 3.4m32.6 69.8l1.6 3.4m-42.1-73l2.1 3.2m44.2 63l2.1 3.1M34.1 18.5l2.7 2.7m54.4 54.4l2.7 2.7M29.4 24.1l3.1 2.2m63 44.2l3.1 2.1M25.7 30.5l3.4 1.6m69.8 32.5l3.4 1.6M23.2 37.4l3.6 1m74.4 19.9l3.6 1M21.9 44.7l3.8.3m76.6 6.7l3.8.4m-84.2 0l3.8-.4m76.6-6.7l3.8-.3M23.2 59.3l3.6-1m74.4-19.9l3.6-1M25.7 66.2l3.4-1.6m69.8-32.5l3.4-1.6M29.4 72.6l3.1-2.1m63-44.2l3.1-2.2M39.8 83l2.1-3.1m44.2-63l2.1-3.2m-42.1 73l1.6-3.4m32.6-69.8l1.6-3.4M53.1 89.2l.9-3.7m20-74.3l.9-3.6M60.3 90.5l.3-3.8M67.4 10l.3-3.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M96.1 16.2L60 44.5l3.9 3.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D01414",
    d: "M63.9 48.4l4.5 4.5 27.7-36.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 44.5L31.7 80.6l32.2-32.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M31.7 80.6l36.7-27.7-4.5-4.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariOriginalWordmark);
export default __webpack_public_path__ + "static/media/SafariOriginalWordmark.3ca7eabb61bb4f9327c6c721d65cb1ce.svg";
export { ForwardRef as ReactComponent };